module.exports = __webpack_public_path__ + "media/images/ZipRecruiter_logo_dark-b3b4b32607c27c2803e69a095418c267.svg";